export default __webpack_public_path__ + "static/media/shergilldesign.572ab0f8.png";